import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Coupon } from '../_interfaces/coupons';

@Injectable({
  providedIn: 'root',
})
export class CouponService {

  constructor(private http: HttpClient) {}

  getAllCoupons(params: any): Observable<any> {
    const data =  this.http.post<any>('/users/coupons/get',params);
    return data;
  }

  createUpdateCoupon(type: string, couponObj: Coupon): Observable<any> {
    const apiEndpoint = type === 'ADD'? '/users/coupons' : '/users/coupons/update';
    const data =  this.http.post<Coupon[]>(apiEndpoint, couponObj);
    return data;
  }

  deleteCouponCode(couponId: any) : Observable<any>{
    const data =  this.http.post<Coupon[]>('/users/coupons/delete', {
      id: couponId
    });
    return data;
  }

  // Codes an agent can offer for this basket, and how each one fits it.
  getSuggestedCoupons(params: {
    items: any[];
    cartTotal: number;
    netTotal: number;
    customerId: number;
    userType: string;
  }): Observable<SuggestedCoupon[]> {
    return this.http.post<SuggestedCoupon[]>('/users/coupons/suggest', params);
  }

  validateAndGetCouponCode(couponCode: string,customerId: number, editMode: boolean): Observable<Coupon> {
    const data =  this.http.post<Coupon>('/users/coupons/code',{couponCode,customerId,editMode});
    return data;
  }


}

export interface SuggestedCoupon {
  code: string;
  description: string;
  value: number;
  percent: boolean;
  minSpend: number | null;
  maxSpend: number | null;
  expires: string | null;
  oncePerCustomer: boolean;
  usesLeft: number | null;
  alone: boolean;
  excludesSale: boolean;
  freeGift: boolean;
  staffOnly: boolean;
  customerSpecific: boolean;
  restrictedToProducts: boolean;
  restrictedToCategories: boolean;
  timesUsed: number;
  recentUses: number;   // orders that used it in the last `windowDays`
  windowDays: number;
  status: 'applies' | 'needsSpend' | 'notForBasket' | 'emptyBasket' | 'overMax';
  shortfall: number;
  saving: number;
}
